import { render, staticRenderFns } from "./OrganizationCard.vue?vue&type=template&id=3da44bc9"
import script from "./OrganizationCard.vue?vue&type=script&lang=js"
export * from "./OrganizationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports